import * as React from 'react';

const EmptySearchResults = ({ show }): JSX.Element | null =>
  show ? <div className="empty-search-results">No matching search results.</div> : null;

export default EmptySearchResults;
